import { render, staticRenderFns } from "./App.vue?vue&type=template&id=076f8651&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076f8651",
  null
  
)

export default component.exports